(function () {
    'use strict';
    angular.module('Directives').directive('bbaCompanyUserAccessPermissions', bbaCompanyUserAccessPermissions);
    bbaCompanyUserAccessPermissions.$inject = [
        'toastr',
        '$uibModal',
        'ClientService'
    ];

    function bbaCompanyUserAccessPermissions(toastr, $uibModal, ClientService) {
        return {
            restrict: 'E',
            replace: true,
            require: '^form',
            templateUrl: '/templates/directives/components/administration/bba-company-user-access-permissions.html',
            scope: {
                ngModel: '='
            },
            link: bbaCompanyUserAccessPermissionsLink
        }

        function bbaCompanyUserAccessPermissionsLink($scope) {
            const vm = this;
            $scope.company = $scope.ngModel || [];
            $scope.displayCompany = [];
            $scope.searchData = searchData;
            $scope.initOffice = initOffice;


            $scope.addAccessCompany = function (item) {
                const modal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/administration/modal/add-company-access.html',
                    controller: 'CompanyAccessModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        companies: () => {
                            return $scope.company;
                        },
                        selectedCompany: () => {
                            return item || null;
                        }
                    },
                    appendTo: $('body')
                });

                modal.result.then(res => {
                    if (!res) { return }
                    displayCompany(res)

                })
            }

            $scope.remove = function (item) {
                const i = $scope.company.findIndex(data => data.id === item.id);
                $scope.company[i].active = false;
                $scope.ngModel = $scope.displayCompany;
                toastr.success('Successfully remove!', 'Success');
                tableReload()
            }

            init();

            function init() {
                if (!$scope.company) {
                    return;
                }
                $scope.company.forEach(company => {
                    company.active = true;
                });
                $scope.displayCompany = $scope.company;

            }

            function displayCompany(res) {
                const offices = [];
                res.offices.forEach(item => {
                    offices.push(item)
                })

                // validation 
                $scope.company.forEach(company => {
                    if (company.companyName === res.selectedCompany.name) {
                        company.id = res.selectedCompany.id
                        company.active = true
                        company.companyName = res.selectedCompany.name
                        company.offices = res.offices
                    } else {
                        $scope.company.push({
                            id: res.selectedCompany.id,
                            active: true,
                            companyName: res.selectedCompany.name,
                            offices: res.offices
                        })
                    }
                });



                $scope.ngModel = $scope.company;
                $scope.displayCompany = $scope.company;
            }

            function tableReload() {
                $scope.displayCompany = $scope.company.filter(company => company.active === true);
            }

            function initOffice(data) {
                if (!data.length) {
                    tableReload()
                    return
                }
                const searchData = []
                data.forEach(item => {
                    searchData.push(item.name)
                })
                $scope.displayCompany = $scope.company.filter(company => searchData.includes(company.companyName));

            }

            function searchData(val) {

                ClientService.Company.getAll(
                    res => {
                        $scope.companies = res.content;
                    },
                    err => {
                        console.log(err)
                    }, { size: 500, active: true, name: val }
                )
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/directives/component/administration/bba-company-user-access-permissions.js